<div class="carousel-container">

  <img [class.hidden]="position == 0" alt="" class="more-arrow arrow-left" src="./assets/images/left_arrow.png" (click)="moveLeft()">

  <div class="carousel-content">

    <div class="reviews-container">
      <div class="review-box" *ngFor="let review of reviews">
        <div class="stars">
          <img class="gold-star" src="./assets/images/gold_star_full.png" alt="">
          <img class="gold-star" src="./assets/images/gold_star_full.png" alt="">
          <img class="gold-star" src="./assets/images/gold_star_full.png" alt="">
          <img class="gold-star" src="./assets/images/gold_star_full.png" alt="">
          <img class="gold-star" src="./assets/images/gold_star_full.png" alt="">
        </div>
        <div class="r-title">
          <span class="open-quote">“</span>
          {{review.title}}
        </div>
        <div class="r-text">{{review.text}}</div>
        <div class="r-subline">{{review.subline}}</div>
      </div>
    </div>

  </div>

  <img [class.hidden]="position == reviewCount - 1" alt="" class="more-arrow" src="./assets/images/right_arrow.png" (click)="moveRight()">

</div>
